













import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class MemberCRMContactCallHistory extends FeedbackComponent {

  @Prop(Object) crmContactDetails!: any;

  @Action('getMemberContactCallHistory', StoreNamespace.CUSTOMER_SERVICE) getMemberContactCallHistory: any;

  private columns: GridColumn[] = [];

  mounted() {
    this.initColumns()

    this.getMemberContactCallHistory({
      requestorCallback: this,
      pathVariable: this.crmContactDetails.crmId
    })
  }

  private initColumns(): void {
    this.columns.push({property: 'updatedUser', header: 'MemberCRMContactCallHistory.updatedUser'} as GridColumn)
    this.columns.push({property: 'updatedDate', header: 'MemberCRMContactCallHistory.updatedDate'} as GridColumn)
    this.columns.push({property: 'callDetails', header: 'MemberCRMContactCallHistory.callDetails'} as GridColumn)
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/getMemberContactCallHistory':
        this.$emit('successResults', data)
    }
  }
}

